import { Link, useLocation } from 'react-router-dom';
import styles from './ComingSoonPage.module.css';
import { Seo } from '../components/Seo';

export function ComingSoonPage({ title = '서비스 준비중입니다', description }) {
  const desc =
    description ??
    '더 나은 콘텐츠로 찾아뵙기 위해 준비하고 있습니다. 빠른 시일 내에 공개될 예정이니 조금만 기다려 주세요.';

  const { pathname } = useLocation();

  return (
    <main className={styles.main}>
      <Seo noindex title={`${title} — medilawyer`} description={desc} path={pathname} />
      <div className={styles.box}>
        <span className={styles.eyebrow}>Coming Soon</span>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.desc}>{desc}</p>
        <div className={styles.actions}>
          <Link to="/" className={styles.primary}>
            홈으로 돌아가기
          </Link>
          <Link to="/contract" className={styles.secondary}>
            계약 안내 보기
          </Link>
        </div>
      </div>
    </main>
  );
}
